export default "__VITE_ASSET__BvqLEZbp__"